import axios from "axios";
import { clearAdminSession, isAdminPath } from "./auth";

export const API_BASE = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

if (
  typeof window !== "undefined" &&
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1" &&
  API_BASE.includes("localhost")
) {
  console.error(
    "REACT_APP_BACKEND_URL is still localhost. Set it in Vercel to your Oracle API URL (e.g. https://api.xluma.in) and Redeploy."
  );
}

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
});

api.interceptors.request.use((config) => {
  if (typeof window !== "undefined" && isAdminPath(window.location.pathname)) {
    const token = localStorage.getItem("admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      typeof window !== "undefined" &&
      isAdminPath(window.location.pathname) &&
      !window.location.pathname.includes("/admin/login")
    ) {
      clearAdminSession();
      window.location.assign("/admin/login");
    }
    return Promise.reject(error);
  }
);
